import * as Inspector from 'avo-inspector';

import Avo from './Avo';
import { Gatekeeper } from '../destinations/gatekeeper/gatekeeper';

const isDevelopment = process.env.APP_ENV !== 'production';

const inspector = new Inspector.AvoInspector({
  apiKey: Avo.avoInspectorApiKey,
  env: isDevelopment ? Inspector.AvoInspectorEnv.Dev : Inspector.AvoInspectorEnv.Prod,
  version: process.env.APP_REVISION,
  appName: 'Merchant Admin',
});

const avoInit = () => {
  Avo.initAvo(
    {
      env: isDevelopment ? Avo.AvoEnv.Dev : Avo.AvoEnv.Prod,
      inspector,
    },
    {},
    Gatekeeper,
  );
};

export default avoInit;
